// extracted by mini-css-extract-plugin
export default {"beyondText":"uTNb2GP9cxeYQlJZnDSa","overUnderText":"uFEZa041FendTFspHxqA"};